import { render, staticRenderFns } from "./PasiDefaultForm.vue?vue&type=template&id=bc000054&"
import script from "./PasiDefaultForm.vue?vue&type=script&lang=js&"
export * from "./PasiDefaultForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports